import React from "react";
import "./lead-qualification-lead-status.scss";

const statusColors: { [key: string]: string } = {
  "New Lead": "new-lead",
  "In Progress": "in-progress",
  Converted: "converted",
  "Closed-Won": "closed-won",
  "Closed-Lost":"closed-lost",
  Qualified: "qualified",
  "Not Qualified": "not-qualified",
  "Contact Attempted": "contact-attempted",
};

const LeadsStatus: React.FC<{ status: string }> = ({ status }) => {
  return (
    <span className={`status-badge ${statusColors[status]}`}>{status}</span>
  );
};

export default LeadsStatus;
